export default {
  sendMessagePlaceholder: 'Skicka meddelande till jaktlaget',
  readMessagesErrorMessage: 'Det gick inte att läsa in alla meddelanden. Vänligen försök igen.',
  sendMessageErrorMessage: 'Ett fel inträffade och det gick inte att skicka meddelandet. Vänligen försök igen.'
}
